<template>
  <div style="text-align: left">
    <div class="mt-3">
      <div class="container">
        <div class="row mt-3">
          <div class="sectionHead">
            Explore Merchants
          </div>
          <Splide :options="category_banner">
            <SplideSlide v-for="items in Banners" :key="items.id">
              <a>
                <img
                  :src="items.Banner_image.url"
                  alt="Sample 1"
                  style="height:95%;width: 100%;border-radius: 16px; rgb(221 11 126 / 34%) 0px 4px 8px 0px;transition: 0.3s;"
                />
              </a>
            </SplideSlide>
          </Splide>
        </div>

        <div v-if="loading" class="loading">
          <br /><br /><br /><br /><br />
          <pulse-loader color="#000000" size="10px"></pulse-loader>
        </div>
        <div class="row mt-1" v-if="loadedData">
          <div
            v-for="merc in mercList"
            :key="merc.id"
            class="post-exit
            item col-6 "
          >
            <div class="product-card">
              <a :href="'/m/merchant/' + merc.id">
                <div class="badge">
                  {{ merc.merchant_discount }}
                </div>
                <div class="product-tumb">
                  <img
                    v-if="merc.banner_image == null"
                    :src="merc.manage_merchants[0].rectBannerLink"
                    alt=""
                    style="height:100%; width:100%;"
                  />
                  <img
                    v-else
                    :src="merc.banner_image.formats.thumbnail.url"
                    alt=""
                    style="height:100%; width:100%;"
                  />
                </div>

                <div class="product-details text-center">
                  <h4 style="font-family:Lato">
                    <a href="" style="font-size:15px;color:white;">  {{ merc.merchant_name }}</a>
                  </h4>

                  <div class="product-bottom-details">
                    <div
                      class="content animated fadeInLeft"
                      style="text-align:center;"
                    >
                      <span class="bg animated fadeInDown" v-for="list in merc.merchant_type" :key="list.id"> {{ list.Type }}</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toVue3 from "vue-2-3/to-vue-3";
import Vue2 from "vue2";
import * as Vue3 from "vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Strapi from "../services/strapi-services.js";
const strapi = new Strapi();
toVue3.register(Vue2, Vue3);

export default {
  name: "MobDealsExploreView",
  components: {
    PulseLoader,
  },
  setup() {
    const category_banner = {
      type: "fade",
      rewind: true,
      height: "200px",
      autoplay: true,
      arrows: false,
      pagination: true,
    };

    return { category_banner };
  },
  data() {
    return {
      type: [],
      mercList: [],
      finalId: 0,
      loading: true,
      loadedData: false,
      language: "php",
      Banners: [],
    };
  },
  created() {
    this.getExploreMerchantDeals();
    this.getCategoryBanner();
  },
  methods: {
    getExploreMerchantDeals() {
      strapi
        .getMerchantDeals()
        .then((res) => {
          this.mercList = res.data;
          console.log("__MERCHANT_LIST:", this.mercList);
          this.loading = false;
          this.loadedData = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCategoryBanner() {
      let parameter = "alldeals";
      console.log("BANNER_TAG_PARAMETER__ ", parameter);

      strapi
        .getTheCategoryPageBannerByCatName(parameter)
        .then((res) => {
          this.Banners = res.data;
          console.log("BANNER_LIST_ :", this.Banners);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.loading {
  margin-left: 10%;
}
.responsive-iframe {
  position: relative;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.carousel__item {
  min-height: 200px;
  width: 100%;
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}

.heroline1 {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 50px;
  line-height: 50px;

  color: #393939;
}

.heroline2 {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;

  color: #393939;
}

.primaryButton {
  width: 200px;
  height: 45px;
  left: 225px;
  top: 426px;

  background: #2d3a53;
  text-decoration: none;
}

.iconExpHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  /* line-height: 22px; */
  color: #393939;
}

.iconExpBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
  text-align: center;
}

.faqHeader {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  /* line-height: 22px; */
  color: #393939;
}

.faqText {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 10px;
  color: #393939;
}

.sectionHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  /* line-height: 42px; */

  color: #393939;
}

.sectionBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #393939;

  opacity: 0.8;
}

.sectionIntro {
  max-width: 500px;
}

.sectionKoko {
  padding-top: 60px;
  padding-bottom: 60px;
  padding: 5%;
}

.stepHead {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  color: #393939;
}

.stepBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;

  color: #767676;
  padding-top: 6px;
  padding-bottom: 20px;
}

a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
  text-decoration: none;
}

.kokoWebButtons {
  background-color: #022078;
  border: 0;
  height: 50px;
  width: 100%;
  font-weight: bolder;
}

.playicon {
  position: relative;
}

.center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.stepperHead {
  font-size: 50px;
  font-weight: bolder;
}

.stepperBody {
  font-size: 16px;
}

/* discount amount */

.product-card {
  position: relative;
  box-shadow: 0 2px 7px #dfdfdf;
  background-color: #f8f5f1;
  padding-bottom: 5px;
}

.badge {
  font-family: "Lato";
  position: absolute;
  left: 0;
  top: 20px;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 700;
  background: #3f8952;
  color: #fff;
  /* border-radius: 1px; */
  padding: 3px 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 0 3px 10px rgb(0 0 0 / 20%);
  white-space:normal;
  max-width: 100%;
}

.badge2 {
  font-family: "Lato";
  position: absolute;
  right: 0;
  top: 85px;
  /* text-transform: uppercase; */
  font-size: 9px;
  font-weight: 700;
  background: #000000;
  color: #fff;
  /* border-radius: 1px; */
  padding: 3px 10px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  box-shadow: 0 3px 10px rgb(0 0 0 / 20%);
}

.product-tumb {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
}

.product-tumb img {
  max-width: 100%;
  max-height: 100%;
}
.product-details {
  padding: 5px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  background-color: #5f5b5b;
  box-shadow: 0 3px 10px rgb(0 0 0 / 20%);
}

.product-details h4 a {
  font-weight: 500;
  display: block;
  margin-bottom: 5px;
  color: #363636;
  text-decoration: none;
  transition: 0.3s;
  font-family: Lato;
}
.product-details h4 a:hover {
  color: #fbb72c;
}

.product-details p {
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 18px;
  color: #999;
}

.product-bottom-details {
  overflow: hidden;
  border-top: 1px solid #eee;
}

.product-bottom-details div {
  float: left;
  width: 100%;
}

.bg {
  display: inline-block;
  color: #000000;
  background: #ffffff;
  padding: 2px 9px;
  border-radius: 50px;
  font-size: 9px;
  box-shadow: 0 3px 10px rgb(0 0 0 / 20%);
}
</style>